import { useState } from "react";
import { motion, Variants, Easing } from "framer-motion";
import SendEmail from "../../Functions/emailFunctions";
import Section from "../Common/Section";
import "./style.scss";

interface SmallContactFormProps {
  order?: "odd" | "even";
}

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" as Easing },
  },
};

const SmallContactForm: React.FC<SmallContactFormProps> = ({ order }) => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNmb, setPhoneNmb] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");

  function preSendEmail() {
    const result = SendEmail(name, email, phoneNmb, title, message);

    if (typeof result === "string") {
      setErrorMsg(result);
    } else if (result && typeof result.then === "function") {
      result.then((res) => {
        if (res) setErrorMsg(res);
      });
    }

    setName("");
    setEmail("");
    setPhoneNmb("");
    setTitle("");
    setMessage("");
  }

  return (
    <Section variant={order} className="smallContactForm">
      <div className="sectionHeader">
        <h2 className="title">Get in Touch</h2>
        <p className="description">
          Have a question or need a quote? Contact us below and we'll get back
          to you as soon as possible.
        </p>
      </div>
      <motion.form action="#" variants={itemVariants}>
        <input
          type="text"
          placeholder="Enter your Name..."
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="email"
          placeholder="Enter your Email..."
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="text"
          placeholder="Enter your Phone Number..."
          value={phoneNmb}
          onChange={(e) => setPhoneNmb(e.target.value)}
        />
        <input
          type="text"
          placeholder="Enter the Email Title..."
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <textarea
          placeholder="Enter your Message..."
          rows={3}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>
        <button type="button" onClick={() => preSendEmail()}>
          Send Message
        </button>
        {errorMsg ? <p className="subheading">{errorMsg}</p> : null}
      </motion.form>
    </Section>
  );
};

export default SmallContactForm;
